<template>
  <el-dialog
    id="app"
    v-el-drag-dialog
    width="1000px"
    :close-on-click-modal="false"
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_SelectBill')"
    append-to-body
    :show-close="false"
    @close="cancel"
  >
    <search-item
      ref="searchItem"
      :show-more-scheme="true"
      :show-simple="true"
      :expand-adv="true"
      :search-item-code="$t('Clearing.AddToBillQueryList')"
      config-module="5051"
      :auto-init="true"
      append-to-body
      :custom-search-items="customSearchItems"
      :col-settings="{
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
        xl: 12
      }"
      @advSearchItemCallBack="fetchData"
      @click-more="value=>isAdvancedQuery=value"
    >
      <div v-show="showAgentBilling" slot="operations">
        <span style="padding-left: 10px;">{{ $t('CargoMsg.Cargo_BillOfType') }}</span>
        <el-radio-group v-model="billingType" :disabled="true" no="1" style="padding-left: 10px;">
          <el-radio :label="0">{{ $t('CargoMsg.Cargo_Domestic') }}</el-radio>
          <el-radio :label="1">{{ $t('CargoMsg.Cargo_International') }}</el-radio>
          <el-radio :label="2"><span style="color: #1f75d5;font-size: 14px">{{ $t('CargoMsg.Cargo_AgentBilling') }}</span></el-radio>
        </el-radio-group>
      </div>
    </search-item>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        config-module="190906"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :grid-params.sync="gridParams"
        :row-data="rowData"
        :style="{width:'100%',height:'300px'}"
      />
    </div>
    <div id="footer-wrapper" class="pagination-wrapper">
      <div style="display: flex;justify-content: flex-end;flex-wrap: wrap;margin-top: 10px;">
        <div v-if="totalAmountToCurrency.selectedCount > 0"><span>选中 {{ totalAmountToCurrency.selectedCount }}：</span></div>
        <charge-currency-total-group
          v-if="reCalc"
          :amount-to-currency="localCurrency"
          data-field="amount"
          currency-field="currency"
          ar-field="ar"
          type="both"
          :data-provider="totalAmountToCurrency.dataProvider"
        />
      </div>
      <cargo-pagination
        config-module="190906"
        :total="searchConditions.total"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
    </div>
    <div slot="footer">
      <el-button type="primary" no="2" size="mini" @click="confirmBillingGroup">{{ $t('Invoice.invoice_confirm') }}</el-button>
      <el-button size="mini" no="3" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { queryAddBillingList } from '@/api/clearing/billingNative'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getGridSelected } from '@/utils/agGrid'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { formatNumberToThousands } from '@/utils'
import chargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import { Once } from '@/utils/commonUtil'
import { cache } from '@/utils/cacheManager'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'

export default {
  name: 'JoinBillDialog',
  components: { searchItem, chargeCurrencyTotalGroup },
  props: {
    visible: { type: Boolean, required: true },
    addBillingConditions: { type: Object, required: true },
    onlyHasAgentBill: { type: Boolean, default: false }
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      innerVisible: this.visible,
      customSearchItems: [], // 自定义高级查询项
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        pagination: false,
        onSelectionChanged: this.toRefreshSelectedCount
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      searchConditions: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 10,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      defaultSearchConditions: {
        accountId: 0, // 结算对象ID
        exceptKeys: [], // 在查询中想要例外的对象列表
        billingType: '', // 对账单类型
        hasBillingGroup: -1, // 是否做过对账单
        clearingState: -1,
        isAr: -1
      },
      totalAmountToCurrency: { // 右下角合计组件相关参数
        selectedCount: 0,
        dataProvider: [], // 数据源
        displayAndCountFieldList: [],
        chargeCountGroupDataProvider: [] // 弹出框数据源
      },
      once: new Once(this),
      billingType: 2, // 默认代理分成账单
      isAdvancedQuery: false, // 是否高级查询
      billingTypeConfig: ''
    }
  },
  computed: {
    showAgentBilling() {
      return this.isAdvancedQuery && this.billingTypeConfig && this.billingTypeConfig.indexOf('2') > -1 && this.defaultSearchConditions.billingType && this.defaultSearchConditions.billingType !== '国内账单'
    }
  },
  created() {
    this.columnDefs = [
      {
        headerName: '', checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      { headerName: this.$t('Billing.billingCharge_billNo'), field: 'billingNo', width: 200 },
      { headerName: this.$t('Billing.billingView_billType'), field: 'billingType', width: 200 },
      { headerName: this.$t('Invoice.invoice_revenueAndExpenditureType'), field: 'ar', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.chargeReceivableLabelFun(params.value)
        } },
      { headerName: this.$t('Billing.billingJob_settleAccountsTo'), field: 'accountId', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        } },
      { headerName: this.$t('Billing.billingJob_settlementAgent'), field: 'settlementAgentId', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        } },
      { headerName: this.$t('Billing.billingJob_invoiceHeader'), field: 'title', width: 200 },
      { headerName: this.$t('Billing.billingCharge_businessNumber'), field: 'jobNo', width: 200 },
      { headerName: this.$t('Payment.etd'), field: 'jobEtd', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        } },
      { headerName: this.$t('Payment.eta'), field: 'jobEta', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        } },
      { headerName: this.$t('Billing.billingCharge_vesselAndVoyage'), field: 'jobVesselVoyageFlight', width: 200 },
      { headerName: this.$t('Billing.billingJob_billStatus'), field: 'state', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.billingStateLabelFun(params.value)
        } },
      { headerName: this.$t('Billing.billingCharge_currency'), field: 'currency', width: 200 },
      { headerName: this.$t('Billing.billingJob_amountOfMoney'), field: 'amount', width: 200,
        cellRenderer: (params) => {
          return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value, 2), 2)
        } },
      { headerName: this.$t('Billing.billingJob_totalCurrency'), field: 'currencyAmount', width: 200 },
      { headerName: this.$t('Billing.billingCharge_remarks'), field: 'remark', width: 200 }
    ]
    const addBillingConditions = this.addBillingConditions
    const defaultSearchConditions = this.defaultSearchConditions
    if (addBillingConditions.hasOwnProperty('accountId')) {
      defaultSearchConditions.accountId = addBillingConditions.accountId
    }
    if (addBillingConditions.hasOwnProperty('billingType')) {
      defaultSearchConditions.billingType = addBillingConditions.billingType
    }
    if (addBillingConditions.hasOwnProperty('hasBillingGroup')) {
      defaultSearchConditions.hasBillingGroup = addBillingConditions.hasBillingGroup
    }
    if (addBillingConditions.hasOwnProperty('exceptKeys')) {
      defaultSearchConditions.exceptKeys = addBillingConditions.exceptKeys
    }
    // 默认高级查询条件
    const defaultSearchFields = []
    if (defaultSearchConditions.accountId > 0) {
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(defaultSearchConditions.accountId))
      if (company) {
        const searchField = new AdvancedSearchField()
        const options = [{ code: company.cmpIdx, chineseName: company.chineseName, englishName: company.englishName }]
        searchField.itemType = 'select'
        searchField.multiple = 0
        searchField.defaultValue = defaultSearchConditions.accountId
        searchField.itemLabel = 'Billing.billingJob_settlementAgent'
        searchField.itemName = 'billing.SETTLEMENT_AGENT_ID'
        searchField.fieldType = 'FIELD_COMPANY'
        searchField.lock = true
        searchField.dataProvider = options
        searchField.defaultSelected = 1
        searchField.selected = 1
        defaultSearchFields.push(searchField.formatObj2Json())
      }
    }
    if (defaultSearchConditions.billingType) {
      const searchField = new AdvancedSearchField()
      searchField.multiple = 0
      searchField.defaultValue = this.onlyHasAgentBill ? '' : defaultSearchConditions.billingType
      searchField.itemLabel = 'Billing.billingView_billType'
      searchField.itemName = 'billing.BILLINGTYPE'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.lock = true
      searchField.defaultSelected = 1
      searchField.selected = 1
      searchField.action = 2
      searchField.dropdownDataRef = 'BillingConstants.BILLING_TYPE"'
      searchField.dataCacheKey = 'local_cache_BillingConstants$BILLING_TYPE2'
      defaultSearchFields.push(searchField.formatObj2Json())
    }
    if (defaultSearchFields.length > 0) {
      this.customSearchItems = defaultSearchFields
    }
    this.setLocalCurrency()
  },
  beforeMount() {
    this.billingTypeConfig = String(cache.config.get('billingType'))
    this.isAdvancedQuery = true
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    fetchData(conditions) {
      this.searchConditions.snapshotConditions = [...conditions]
      this.searchConditions.pageNum = 1
      this.toAdvQueryList(conditions)
    },
    // 分页触发查询
    fetchDataByPage() {
      this.toAdvQueryList(this.searchConditions.snapshotConditions)
    },
    async toAdvQueryList(conditions) {
      const defaultSearchConditions = this.defaultSearchConditions
      // 对账单中已经存在的账单要去掉
      if (defaultSearchConditions.exceptKeys.length > 0) {
        const exceptKeysCondition = new AdvancedSearchOption(null, 'billing.UUID', defaultSearchConditions.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
        conditions.push(exceptKeysCondition.formatObj2Json())
      }
      // 查询没有做过对账单的账单
      if (defaultSearchConditions.hasBillingGroup !== -1) {
        const hasBillingGroupCondition = new AdvancedSearchOption('FIELD_IS_NOT_NULL', 'billing.BILLING_GROUP_UUID', defaultSearchConditions.hasBillingGroup === 0, defaultSearchConditions.hasBillingGroup === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code)
        conditions.push(hasBillingGroupCondition.formatObj2Json())
      }
      // 账单状态不能等于3
      const stateCondition = new AdvancedSearchOption(null, 'billing.STATE', 3, OperatorConstants.OPERATOR_UNEQUAL.code)
      conditions.push(stateCondition.formatObj2Json())
      if (this.showAgentBilling) {
        if (AdvancedSearchOption.hasField('billing.BILLINGTYPE', conditions)) {
          for (const item of conditions) {
            if (item.fieldName === 'billing.BILLINGTYPE') {
              if (item.operator === OperatorConstants.OPERATOR_EQUAL.code) {
                if (item.value === '国外账单') {
                  item.operator = OperatorConstants.OPERATOR_IN.code
                  item.value = ['国外账单', '代理分成账单']
                  break
                }
              }
            }
          }
        } else {
          if (this.onlyHasAgentBill) {
            const billTypeCondition = new AdvancedSearchOption(null, 'billing.BILLINGTYPE', '代理分成账单', OperatorConstants.OPERATOR_EQUAL.code)
            conditions.push(billTypeCondition.formatObj2Json())
          }
        }
      }
      const requestBody = { conditions, requires: this.requires, branchId: this.$store.getters.currentOfficeId, pageNum: this.searchConditions.pageNum, pageSize: this.searchConditions.pageSize }
      this.loading = getLoading()
      queryAddBillingList(requestBody).then(res => {
        this.rowData = res.data.list
        this.searchConditions.total = Number(res.data.total)
        this.totalAmountToCurrency.dataProvider = this.rowData
        this.totalAmountToCurrency.selectedCount = 0
      }).finally(() => {
        this.loading.close()
      })
    },
    confirmBillingGroup() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('act.billing.pleaseSelectBilling'))
        return
      }
      this.$emit('backBillingGroupDetail', chooseRows)
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCount(event) {
      this.filterChange()
      // this.once.excute(this.refreshSelectedCount, [], 200)
    },
    filterChange() {
      const selections = getGridSelected(this.gridOptions)
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCount, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length == this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [], 200)
            }
            if (hasDisplay.length < this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
            }
          } else {
            this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCount(arg, selections) {
      if (arg == 0) {
        this.totalAmountToCurrency.dataProvider = selections
        this.totalAmountToCurrency.selectedCount = selections.length
      } else if (arg == 1) {
        this.totalAmountToCurrency.dataProvider = selections
        this.totalAmountToCurrency.selectedCount = 0
      } else {
        this.totalAmountToCurrency.dataProvider = this.rowData
        this.totalAmountToCurrency.selectedCount = 0
      }
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>

<style lang="scss">
</style>
